import React, { useState } from "react";
import { X, Zap, Loader2 } from "lucide-react";

export default function PoptavkaModal({ open, onClose }) {
    const [loading, setLoading] = useState(true);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center" data-testid="poptavka-modal-overlay">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose} />

            {/* Modal */}
            <div className="relative w-full max-w-4xl mx-4 bg-white rounded-2xl shadow-2xl overflow-hidden"
                style={{ height: "min(85vh, 720px)" }}
                data-testid="poptavka-modal">

                {/* Header */}
                <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100"
                    style={{ background: "linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)" }}>
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: "var(--sg-primary, #22c55e)" }}>
                            <Zap size={16} className="text-white" />
                        </div>
                        <div>
                            <h2 className="text-sm font-bold text-gray-900">Poptej reseni na miru</h2>
                            <p className="text-xs text-gray-500">Vyplnte formular a ozveme se vam</p>
                        </div>
                    </div>
                    <button onClick={onClose}
                        className="w-8 h-8 rounded-lg bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
                        data-testid="poptavka-modal-close">
                        <X size={16} className="text-gray-500" />
                    </button>
                </div>

                {/* Loading indicator */}
                {loading && (
                    <div className="absolute inset-0 top-[52px] flex items-center justify-center bg-white z-10">
                        <div className="flex flex-col items-center gap-3">
                            <Loader2 size={28} className="text-green-500 animate-spin" />
                            <p className="text-sm text-gray-400">Nacitam formular...</p>
                        </div>
                    </div>
                )}

                {/* Iframe */}
                <iframe
                    src="https://poptavka.solar-green.cz"
                    title="Poptavka Solar-Green"
                    className="w-full border-0"
                    style={{ height: "calc(100% - 52px)" }}
                    onLoad={() => setLoading(false)}
                    data-testid="poptavka-iframe"
                />
            </div>
        </div>
    );
}
